<div nxModalContent class="high-risk-modal">
  <div class="nx-margin-bottom-3m u-text-center">
    <h2 nxHeadline="subsection-large" class="high-risk-modal__title">{{ 'sports-list.headline' | translate }}</h2>
  </div>

  <nx-tab-group [(selectedIndex)]="currentIndex" appearance="expert" mobileAccordion="false">
    <nx-tab [label]="'sports-list.leisure.label' | translate">
      <div class="nx-margin-top-s">
        <ul nxList>
          <li *ngFor="let item of 'sports-list.leisure.list' | translate">{{ item }}</li>
        </ul>
      </div>
    </nx-tab>
    <nx-tab [label]="'sports-list.extreme.label' | translate">
      <div class="nx-margin-top-s">
        <ul nxList>
          <li *ngFor="let item of 'sports-list.extreme.list' | translate">{{ item }}</li>
        </ul>
      </div>
    </nx-tab>
  </nx-tab-group>
</div>
<div nxModalActions class="modal-actions">
  <app-modal-close></app-modal-close>
</div>
